<template>
    <div :id="'voucher--' + element.id"
         class="item pb-3 mb-5 border-bottom">
        <transition mode="out-in" name="slide">
            <div v-if="!isEdit"
                 class="row">
                <!--            Name -->
                <h2 v-if="element.offer" class="col-12">{{ element.offer }}</h2>

                <p class="col-12"><i class="fad fa-calendar-week"></i> Gültig: {{ startDate }}
                    {{ endDate }} </p>
                <!--            Description -->
                <div v-if="element.conditions"
                     class="col-12"
                     v-html="element.conditions"></div>

                <!--                Code -->
                <div v-if="element.code"
                     class="col-12 col-md-4 my-3">
                    <p><b>Gutscheincode:</b> {{ element.code }}</p>
                </div>

                <!--                Downlodas -->
                <div class="col-12 col-md-4 my-3">
                    <p><b>Downloads:</b> {{ element.downloads > 0 ? element.downloads : '0' }}</p>
                </div>

                <div v-if="element.media.length > 0"
                     class="col-12 col-md-4 my-3 text-right">
                    <a :href="element.media[0].url"
                       class="btn btn-outline-secondary btn-sm"
                       target="_blank">
                        Gutschein herunterladen <i class="fad fa-download"></i>
                    </a>
                </div>
                <!--            Buttons -->
                <buttons :isLoading="isLoading"
                         @delete="deleteItem(element.id)"
                         @edit="isEdit = true"></buttons>
            </div>
            <buero-form
                v-if="isEdit"
                :elementValues="this.element"
                :schema="schema"
                method="patch"
                url="/api/merchant/vouchers"
                @cancel="cancelEdit"
                @updateItem="updateItem"></buero-form>
        </transition>
    </div>
</template>

<script>
import {Form} from './Form';

export default {
    name: 'Voucher',
    props: {
        item: Object,
    },
    data() {
        return {
            isEdit: false,
            element: this.item,
            searchString: null,
            isLoading: false,
            schema: (new Form(this.item.offer + ' bearbeiten')).schema(),
        };
    },

    methods: {
        cancelEdit() {
            this.isEdit = false;
        },
        updateItem(payload) {
            this.element = payload;
            this.isEdit = false;
        },
        deleteItem(payload) {
            this.$swal({
                title: 'Sind Sie sicher?',
                text: 'Sie können dies nicht rückgängig machen!',
                showDenyButton: true,
                confirmButtonText: `Löschen`,
                denyButtonText: `Nicht löschen`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.isLoading = true;
                    axios.delete('/api/merchant/vouchers/' + payload).then((response) => {
                        this.$swal({
                            title: response.data.message,
                        });
                        this.isLoading = false;
                        this.$emit('deleteItem', payload);
                    }).catch((error) => {
                        this.$swal({
                            icon: 'error',
                            title: 'Es ist ein Fehler aufgetreten',
                        });
                        this.isLoading = false;
                    });
                }
            });
        },
    },

    computed: {
        startDate() {
            return ' von ' + moment(this.element.valid_from).format('LL');
        },
        endDate() {
            if (this.element.valid_from) {
                return ' bis ' + moment(this.element.valid_to).format('LL');
            }
        },
    },

    watch: {
        searchString(newValue) {
            this.searchString = newValue;
        },
    },
};
</script>
